import {
  CheckboxGroupField,
  RadioGroupField,
  SelectField,
  TextEditorField,
} from "components/form/fields";
import { UserField } from "components/form/fields/UserField";
import { Column, Row, Section } from "components/layout";
import { ROLES } from "containers/Permissions";

import { TEXTS } from "../constants";
import { PROVIDER_FIELDS } from "../fields";

export function TiVoAppFormCspSummaryTab() {
  return (
    <>
      <Section header={TEXTS.CSP_SUMMARY.ASSIGNEES_HEADER}>
        <Row>
          <Column>
            <UserField
              {...PROVIDER_FIELDS.CSP_SUMMARY.ASSIGNEE_TAM}
              roleFilter={ROLES.tivo.moderator}
            />
          </Column>
          <Column>
            <UserField
              {...PROVIDER_FIELDS.CSP_SUMMARY.ASSIGNEE_BDM}
              roleFilter={ROLES.tivo.moderator}
            />
          </Column>
        </Row>
      </Section>
      <Row>
        <Column>
          <Section header={TEXTS.CSP_SUMMARY.AGREEMENTS_HEADER}>
            <SelectField {...PROVIDER_FIELDS.CSP_SUMMARY.CONTRACT_STATUS} />
            <RadioGroupField
              {...PROVIDER_FIELDS.CSP_SUMMARY.REQUIRE_CONFIRMATION}
            />
            <SelectField {...PROVIDER_FIELDS.CSP_SUMMARY.GROUP} />
            <CheckboxGroupField {...PROVIDER_FIELDS.CSP_SUMMARY.BIZ_MODEL} />
            <CheckboxGroupField
              {...PROVIDER_FIELDS.CSP_SUMMARY.AGREEMENT_MODEL}
            />
            <SelectField {...PROVIDER_FIELDS.CSP_SUMMARY.CONTRACT_ORIGIN} />
            <TextEditorField
              {...PROVIDER_FIELDS.CSP_SUMMARY.AGREEMENT_SUMMARY}
            />
            <SelectField {...PROVIDER_FIELDS.CSP_SUMMARY.ACR_RIGHTS} />
          </Section>
        </Column>
        <Column>
          <Section header={TEXTS.CSP_SUMMARY.SUMMARY_HEADER}>
            <TextEditorField
              {...PROVIDER_FIELDS.CSP_SUMMARY.REPORTING_OBLIGATIONS}
            />
            <TextEditorField
              {...PROVIDER_FIELDS.CSP_SUMMARY.PROMO_OBLIGATIONS}
            />
            <TextEditorField
              {...PROVIDER_FIELDS.CSP_SUMMARY.PLACEMENT_OBLIGATIONS}
            />
          </Section>
        </Column>
      </Row>
      <Row>
        <Column>
          <TextEditorField {...PROVIDER_FIELDS.CSP_SUMMARY.DEAL_SUMMARY} />
        </Column>
      </Row>
    </>
  );
}
